<template>
  <div class="common_bg">
    <!-- 年月收款 -->
    <div class="collection_list">
      <!-- 本年收款 -->
      <div class="collection_item">
        <img src="@/assets/img/pay_img/year_income.png" />
        <span class="label">{{ $t("lang.本年收款") }}</span>
        <span class="value">{{ monetary + fix(statistics.year) }}</span>
      </div>
      <!-- 本月收款 -->
      <div class="collection_item">
        <img src="@/assets/img/pay_img/currentmonth_income.png" />
        <span class="label">{{ $t("lang.本月收款") }}</span>
        <span class="value">{{ monetary + fix(statistics.month) }}</span>
      </div>
    </div>
    <!-- 筛选 -->
    <el-form :inline="true">
      <!-- 房间名称 -->
      <el-form-item class="input213">
        <el-input
          v-model="params.meterName"
          :placeholder="$t('lang.请输入设备名称')"
          @keyup.enter.native="onClickSearch"
        >
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
      </el-form-item>
      <!-- 资产号 -->
      <el-form-item :label="$t('lang.资产号')" class="input213">
        <el-input
          v-model="params.inmeterno"
          :placeholder="$t('lang.请输入资产号')"
        >
        </el-input>
      </el-form-item>
      <!-- 操作时间 -->
      <el-form-item :label="$t('lang.操作时间')" class="input285">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          align="right"
          unlink-panels
          :range-separator="$t('lang.至')"
          :picker-options="pickerOptions"
          :clearable="false"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 层级名称 -->
      <el-form-item :label="$t('lang.层级名称')" class="input138">
        <el-select v-model="params.rootId">
          <el-option
            v-for="item of levelList"
            :key="item.rootId"
            :label="item.rootName"
            :value="item.rootId"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 查询 -->
      <el-form-item>
        <el-button type="primary" size="medium" @click="onClickSearch">{{
          $t("lang.查询")
        }}</el-button>
      </el-form-item>
      <!-- 导出 -->
      <el-form-item>
        <el-button type="primary" plain size="medium" @click="onClickExport">{{
          $t("lang.导出")
        }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      max-height="400"
      v-loading="loading"
    >
      <el-table-column
        v-for="item in tableTitle"
        :key="item.prop"
        :prop="item.prop"
        align="center"
        :label="
          item.prop == 'amount'
            ? `${$t('lang.' + item.label)}(${monetary})`
            : $t('lang.' + item.label)
        "
        :formatter="formatter"
        :min-width="item.width"
      >
      </el-table-column>
    </el-table>
    <div class="payment_bottom">
      <el-pagination
        class="bottom_page"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :current-page="params.pageNum"
        @current-change="pageChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import { pickerOptions, CollectionTableTitle } from "./define";
import levelMixin from "@/app/common/mixin/mixin-levelList.js";
export default {
  mixins: [levelMixin],
  data() {
    return {
      params: {
        meterName: "",
        inmeterno: "",
        startTime: "",
        endTime: "",
        rootId: "",
        pageNum: 1,
        pageSize: 10,
      },
      /**统计数据 */
      statistics: {
        year: "",
        month: "",
      },

      //#region 表格
      tableData: [],
      tableTitle: CollectionTableTitle,
      totalCount: 0,
      loading: false,
      //#endregion

      //#region 时间选择器控件
      timeValue: [],
      pickerOptions: pickerOptions,
      //#endregion
      monetary: "元",
    };
  },
  created() {
    this.timeValue = [
      moment().subtract(7, "days").format("YYYY-MM-DD 00:00:00"),
      moment().format("YYYY-MM-DD 23:59:59"),
    ];
    this.iReceiveRangeTime();
    this.iReceiveTatistics();
  },
  mounted() {
    let that = this;
    this.$bus.$on("updateCurrency2", function () {
      that.iReceiveTatistics();
    });
  },
  methods: {
    ...mapActions({
      receiveTatistics: "ZD_ReceiveTatistics",
      receiveRangeTime: "ZD_ReceiveRangeTime",
    }),
    /**获取统计数据 */
    async iReceiveTatistics() {
      this.monetary = localStorage.getItem("monetary");
      try {
        let res = await this.receiveTatistics({});
        if (res.success !== 1) throw new Error("");
        this.statistics.year = this.repnull(res.yearearns, { empty: "" });
        this.statistics.month = this.repnull(res.monthearns, { empty: "" });
      } catch (e) {
        this.statistics.year = "";
        this.statistics.month = "";
      }
    },
    /**获取表格数据 */
    async iReceiveRangeTime() {
      this.loading = true;
      try {
        let res = await this.receiveRangeTime(this.getParams());
        if (res.success !== 1 || this.isnull(res.listitem)) throw new Error("");
        res.listitem.forEach((elem, idx) => {
          elem.idx = (this.params.pageNum - 1) * this.params.pageSize + idx + 1;
        });
        this.tableData = res.listitem;
        this.totalCount = res.totalItemCount;
      } catch (e) {
        this.tableData = [];
        this.totalCount = 0;
      } finally {
        this.loading = false;
      }
    },
    onClickSearch() {
      this.params.pageNum = 1;
      this.iReceiveRangeTime();
    },
    getParams() {
      this.params.startTime = "";
      this.params.endTime = "";
      if (this.timeValue.length > 1) {
        this.params.startTime = this.timeValue[0];
        this.params.endTime = moment(this.timeValue[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      return this.params;
    },
    //#region 表格
    formatter(row, { property }) {
      if (this.isnull(row[property])) return "--";
      if (property == "amount") {
        return this.fix(row[property], { empty: "--" });
      }
      if (property == "kwh") {
        let value = this.fix(row[property], { empty: "--" });
        switch (row.deviceType) {
          case 0:
            row[property] = value != "--" ? value + " kWh" : "--";
            break;
          case 1:
            row[property] = value != "--" ? value + " m³" : "--";
            break;
          default:
            break;
        }
      }
      if (property == "payType") {
        switch (row[property]) {
          case 1:
            return this.$t("lang.支付宝");
          case 2:
            return this.$t("lang.银行卡");
          case 3:
            return this.$t("lang.微信");
          case 10:
            return this.$t("lang.支付宝小程序");
          case 11:
            return this.$t("lang.微信小程序");
          case 103:
            return this.$t("lang.Paystack");
          case -1:
          case 128:
            return this.$t("lang.线下支付");
        }
      }
      return row[property];
    },
    handleSizeChange(size) {
      this.params.pageNum = 1;
      this.params.pageSize = size;
      this.iReceiveRangeTime();
    },
    pageChange(e) {
      this.params.pageNum = e;
      this.iReceiveRangeTime();
    },
    //#endregion

    onClickExport() {
      if (this.isnull(this.tableData))
        return this.$message.warning(this.$t("lang.当前无导出数据"));
      const tempTitle = this.docopy(this.tableTitle);
      tempTitle.shift();
      tempTitle.forEach((elem) => {
        elem.label = this.$t("lang." + elem.label);
      });
      this.$download(this.params, tempTitle, "EXPORT_ReceiveRangeTime", {
        payType: {
          1: this.$t("lang.支付宝"),
          2: this.$t("lang.银行卡"),
          3: this.$t("lang.微信"),
          10: this.$t("lang.支付宝小程序"),
          11: this.$t("lang.微信小程序"),
          103: this.$t("lang.Paystack"),
          128: this.$t("lang.线下支付"),
          "-1": this.$t("lang.线下支付"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.common_bg {
  /deep/ .el-form {
    margin-top: 20px;
  }
  /deep/ .el-form-item {
    margin-right: 20px;
  }
  .el-icon-search {
    padding-left: 5px;
  }
  .input213 /deep/ .el-input {
    width: 230px;
  }

  .input138 /deep/ .el-input {
    width: 138px;
  }
  .input285 /deep/ .el-date-editor--daterange.el-input__inner {
    width: 285px;
  }
}
.collection_list {
  display: flex;
  align-items: center;
  .collection_item {
    height: 85px;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    margin-right: 40px;
    img {
      width: 40px;
      height: 40px;
    }
    color: #333;
    .label {
      margin-left: 36px;
      margin-right: 94px;
      font-size: 16px;
    }
    .value {
      font-size: 18px;
      font-weight: 700;
    }
  }
}
.payment_bottom {
  width: 100%;
  height: 60px;
  .bottom_page {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}
</style>
